var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M47.8,260.969a8.674,8.674,0,0,0,4.79-1.4,2.653,2.653,0,0,1,3.275.279,12.387,12.387,0,0,1,3.935,9.108v1.488a2.753,2.753,0,0,1-2.725,2.781H38.524a2.753,2.753,0,0,1-2.725-2.781v-1.488a12.35,12.35,0,0,1,3.929-9.1A2.653,2.653,0,0,1,43,259.576,8.734,8.734,0,0,0,47.8,260.969Z",
    transform: "translate(-35.799 -245.226)",
    fill: "#ffcfe9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 6.627,
    cy: 6.901,
    rx: 6.627,
    ry: 6.901,
    transform: "translate(5.373)",
    fill: "#ffcfe9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileActive);
export default __webpack_public_path__ + "static/media/icon_profile_active.cb9b5cd1013803feeabf0258493c9cc5.svg";
export { ForwardRef as ReactComponent };